import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import DebugService from '../services/DebugService';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import APIConstants from '../services/APIConstants';
import MultiTabs from './common/inventory/MultiTabs';
import { EBSAvailablecolumns, EBSChangescolumns, EBScolumns } from '../services/InventoryService';
import {
  useZustStore
} from '../state/Zuststore';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import LoadingIndicator from './common/inventory/LoadingIndicator';
import SnackbarNotification, { SNACKBAR_THEME } from './common/SnackbarNotification';
import DownloadIcon from '@mui/icons-material/Download';
import MainTable from './common/inventory/MainTable';
import InventoryApiService from '../services/InventoryApiService';
import { CONST_SITE_LABEL } from './common/Helper';

export default function EBSInventory() {
  const isSmallScreen = useMediaQuery('(max-width: 700px)');
  const [selectedDate, setSelectedDate] = useState();
  const [changesDate, setChangesDate] = useState();
  const [changestoDate, setChangestoDate] = useState();
  const [Changes, setChanges] = useState(null);
  const [data, setData] = useState(null);
  const [dateData, setDateData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showSavings, setShowSavings] = useState(false);
  const [savedata, setSavedata] = useState(null);
  const dopen = useZustStore((state) => state.dopen);
  const addedData = Changes?.addedInstances
  const removeData = Changes?.removedInstances

  useEffect(() => {
    const fetchData = async () => {

      try {
        setShowLoading(true);

        if (error) {
          setChangesDate(null);
          setChangestoDate(null);
        }

        if (!data) {
          await InventoryApiService.getEBSOnDemandPrice()
            .then(res => {
              const availableVolumes = res
              setData(availableVolumes)
            }).catch(err => {
              DebugService.error(`Inventory Component: Get EBS On Demand error`, err)
            }).finally(() => { })
        }

        // Fetch date data if selectedDate is defined
        let dateResponse = null;
        if (selectedDate) {
          await InventoryApiService.getInventoryByDate(APIConstants.ENDPOINT_INVENTORY_EBS, selectedDate)
            .then(res => {
              setDateData(res);
            }).catch(err => {
              DebugService.error(`Inventory Component: `, err)
            }).finally(() => { })
        }

        // Fetch changes data if changestoDate and changesDate are defined
        let changesResponse = null;
        if (changestoDate && changesDate) {
          const dateRequestBody = {
            fromDate: encodeURIComponent(changesDate.toISOString()),
            toDate: encodeURIComponent(changestoDate.toISOString())
          }

          await InventoryApiService.getALLCost(APIConstants.ENDPOINT_INVENTORY_EBS_CHANGES, dateRequestBody)
            .then(res => {
              setChanges(res);
            }).catch(err => {
              DebugService.error(`Inventory Component: `, err)
            }).finally(() => { })
        }

        setError(null);
      } catch (error) {
        setError(error.toString());
        setChangesDate(null);
        setChangestoDate(null);
        setOpenError(true);
        setDateData(null);
        DebugService.error('Current Inventory Type: Fetch data error', error)
      } finally {
        setLoading(false);
        setShowLoading(false);
      }
    };

    fetchData();
  }, [[selectedDate, changesDate, changestoDate]]);

  const handlesave = async () => {
    setShowLoading(true);
    await InventoryApiService.saveData({}
      .then(res => {
        DebugService.log(`Inventory Component: Save data response`, res)
        setSavedata(res)
        setOpen(true)
      })
      .catch(err => {
        DebugService.error(`Inventory Component: Save data response`, err)
      })
      .finally(() => {
        setShowLoading(false);
      })
    )
  }

  const handleClose = (event, reason) => {

    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
    setOpenError(false)
  };

  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | EBS Inventory`
  }, [])

  const volumes = (data && data.length > 0) ? data.flatMap(region => region.volumes) : []

  const rows = volumes?.map(volume => ({
    'Name': volume?.Name,
    'Volumeid': volume?.Volumeid,
    'Type': volume?.Type,
    'Size': volume?.Size,
    'IOPS': volume?.IOPS,
    'Throughput': volume?.Throughput,
    'Created': volume?.Created,
    'Availabilityzone': volume?.Availabilityzone,
    'Attachedresources': volume?.Attachedresources ? volume?.Attachedresources : '-',
    'Volumestate': volume?.Volumestate,
    'Encryption': volume?.Encrypted ? 'Encrypted' : 'Not Encrypted',
    'MultiAttachenabled': volume?.MultiAttachEnabled ? 'Yes' : 'No',
    'OnDemandMonthlyStoragePriceValue': volume?.pricingDetails?.OnDemandMonthlyStoragePriceValue * volume?.Size,
    'OnDemandMonthlyIOPSPriceValue': volume?.pricingDetails?.OnDemandMonthlyIOPSPriceValue * volume?.IOPS,
  }));

  const totalSize = volumes?.reduce((total, volume) => total + volume?.Size, 0);
  const totalIOPS = volumes?.reduce((total, volume) => total + (volume?.IOPS || 0), 0);
  const totalCost = volumes?.reduce((total, volume) => total + volume?.pricingDetails?.OnDemandMonthlyStoragePriceValue * volume?.Size, 0);

  const availableVolumes = rows?.filter(volume => volume?.Volumestate === 'available');

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        flexGrow: 1,
        // height: '100vh',
        overflow: 'auto',
      }}
    >

      {/* <Toolbar /> */}

      <Container
        maxWidth='false'
        sx={{
          mt: '1vw',
          ml: '0',
          mr: '0',
          width: '100%',
          maxWidth: '100%'
        }}

        style={{
          // maxHeight: '87vh',
          // height: '100%',
          // overflowY: 'auto'
          height: 'calc(100vh - 82px)'
        }}
      >
        <Grid component={Paper} container style={{
          marginTop: '80px',
          padding: '10px'
        }}>
          <Grid item>
            <MultiTabs
              childrenA={<Dynamictable
                rows={rows} totalSize={totalSize} totalIOPS={totalIOPS} totalCost={totalCost} data={data} showLoading={showLoading} setShowSavings={setShowSavings} showSavings={showSavings} columns={EBSAvailablecolumns}
              />}

              childrenB={<Datetable
                selectedDate={selectedDate} setSelectedDate={setSelectedDate} columns={EBScolumns} dateData={dateData} showLoading={showLoading} error={error}
              />}

              childrenC={<ChangesDetails columns={EBSChangescolumns}
                addedData={addedData}
                removeData={removeData}
                changesDate={changesDate}
                handlesave={handlesave}
                setChangesDate={setChangesDate}
                changestoDate={changestoDate}
                setChangestoDate={setChangestoDate}
                showLoading={showLoading}
                error={error} />
              }

              childrenD={<Savings EBSAvailablecolumns={EBSAvailablecolumns} availabledata={availableVolumes} />}
            />

            <SnackbarNotification open={open} onCloseHandler={handleClose} message={savedata} theme={SNACKBAR_THEME.GREEN} />
            <SnackbarNotification open={openError} onCloseHandler={handleClose} message={error} theme={SNACKBAR_THEME.RED} />
          </Grid>
        </Grid>
      </Container>
    </Box >
  )
}

export function Dynamictable({ columns, rows, showLoading, totalCost, totalSize, totalIOPS, data }) {

  const handleExportToExcel = () => {
    const exportData = rows || [];
    const formattedDate = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    const titleRow = { Date: `Date: ${formattedDate}` };
    const dataWithDate = [titleRow, ...exportData];
    const ws = XLSX.utils.json_to_sheet(dataWithDate);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(data, 'instances.xlsx');
  }

  return (
    <>
      {showLoading && (
        <LoadingIndicator></LoadingIndicator>
      )}
      {!showLoading && (
        <Grid container xs={12} md={12} lg={12}>
          <Grid item container xs={12} md={12} lg={12} style={{
            marginBottom: '50px'
          }}>
            <Grid item xs={12} md={8} lg={8} style={{ alignSelf: 'end' }}>
              <Typography style={{
                fontWeight: '550'
              }}>
                Volumes ({rows?.length ?? 0})
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Button endIcon={<DownloadIcon />} sx={{ marginLeft: "1rem", textTransform: 'none' }} variant="outlined" color="primary" onClick={handleExportToExcel}>
                Download
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12} md={12} lg={12} style={{
            marginTop: '15px'
          }}>
            <MainTable columns={columns} rows={rows}></MainTable>
          </Grid>

          <Grid item xs={12} md={12} lg={12} style={{
            marginTop: '30px'
          }}>
            <Typography style={{
                fontWeight: '550'
              }}>Savings</Typography>
            <TableContainer >
              <Table>
                <TableHead>
                  <TableRow>

                    <TableCell sx={{ fontWeight: 550 }}>Total Size</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Total IOPS</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Total EBS-storage Cost</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Total IOPS Cost</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>

                    <TableCell>{totalSize} GB</TableCell>
                    <TableCell>{totalIOPS}</TableCell>
                    <TableCell>$ {totalCost?.toFixed(2)}</TableCell>
                  </TableRow>

                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

        </Grid>
      )}

    </>
  )
};

export function Savings({ availabledata, EBSAvailablecolumns, }) {

  const rows = availabledata?.map(volume => ({
    'Name': volume?.Name,
    'Volumeid': volume?.Volumeid,
    'Type': volume?.Type,
    'Size': volume?.Size,
    'IOPS': volume?.IOPS,
    'Throughput': volume?.Throughput,
    'Created': volume?.Created,
    'Availabilityzone': volume?.Availabilityzone,
    'Attachedresources': volume?.Attachedresources ? volume.volume?.Attachedresources : '-',
    'Volumestate': volume?.Volumestate,
    'Encryption': volume?.Encrypted ? 'Encrypted' : 'Not Encrypted',
    'MultiAttachenabled': volume?.MultiAttachEnabled ? 'Yes' : 'No',
    'OnDemandMonthlyStoragePriceValue': volume?.OnDemandMonthlyStoragePriceValue
  }));

  const totalSize = rows?.reduce((total, volume) => total + volume?.Size, 0);
  const totalIOPS = rows?.reduce((total, volume) => total + (volume?.IOPS || 0), 0);
  const totalCost = rows?.reduce((total, volume) => total + (volume?.OnDemandMonthlyStoragePriceValue || 0), 0);


  return (
    <>
      {!availabledata ? <Typography marginTop={10} variant='h5'>No Available Volumes !</Typography> :

        <Grid container xs={12} md={12} lg={12}>
          <Grid item container xs={12} md={12} lg={12} style={{
            marginBottom: '50px'
          }}>
            <Grid item xs={12} md={8} lg={8} style={{ alignSelf: 'end' }}>
              <Typography style={{
                fontWeight: '550'
              }}>
                Availables ({rows?.length ?? 0})
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} md={12} lg={12} style={{
            marginTop: '15px'
          }}>
            <MainTable columns={EBSAvailablecolumns} rows={rows}></MainTable>
          </Grid>

          <Grid item xs={12} md={12} lg={12} style={{
            marginTop: '30px'
          }}>
            <Typography style={{
              fontWeight: '550'
            }}>Savings</Typography>
          </Grid>

          <Grid item xs={12} md={12} lg={12} style={{
            marginTop: '15px'
          }}>
            <TableContainer >
              <Table sx={{ marginTop: '1rem' }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 550 }}>Volume State</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Total Size</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Total IOPS</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Total EBS-storage Cost</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Total IOPS Cost</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Available ({availabledata?.length})</TableCell>
                    <TableCell>{totalSize} GB</TableCell>
                    <TableCell>{totalIOPS}</TableCell>
                    <TableCell>$ {totalCost?.toFixed(2)}</TableCell>
                  </TableRow>

                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      }
    </>
  )

}

export function Datetable({ selectedDate,
  showLoading,
  setSelectedDate,
  dateData,
  columns }) {

  const Daterow = dateData && dateData.length > 0 ? dateData[0]?.Volumes?.map(volume => ({
    'Name': volume.Tags?.find(tag => tag.Key === 'Name')?.Value || '-',
    'Volumeid': volume.VolumeId || '',
    'Type': volume.VolumeType || '',
    'Size': volume.Size,
    'IOPS': volume.Iops,
    'Throughput': volume.Throughput,
    'Created': volume.CreateTime,
    'Availabilityzone': volume.AvailabilityZone,
    'Volumestate': volume.State,
    'Attachedresources': volume.Attachments?.map(attachment => `${attachment.InstanceId} ${attachment.Device} (${attachment.State})`).join(',') || '-',
    'Encryption': volume.Encrypted ? 'Encrypted' : 'Not Encrypted',
    'MultiAttachenabled': volume.MultiAttachEnabled ? 'Yes' : 'No'
  })) : [];

  const handleExportToExcelBYDate = () => {
    const exportData = Daterow || []; // Use Daterow if available,
    const formattedDate = selectedDate.format('MM/DD/YYYY');
    const titleRow = { Date: `Date: ${formattedDate}` };
    const dataWithDate = [titleRow, ...exportData];
    const ws = XLSX.utils.json_to_sheet(dataWithDate);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(data, `instances_${formattedDate}.xlsx`);


  };

  return (
    <>
      {showLoading && (
        // Animate the loading indicator (you can replace this with your own loading component)
        <LoadingIndicator></LoadingIndicator>
      )}

      {!showLoading && (
        <Grid container xs={12} md={12} lg={12}>

          <Grid item xs={12} md={12} lg={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DemoItem label="Select Date">
                  <DatePicker
                    value={selectedDate}
                    onChange={(newDate) => {
                      // const utcDate = newDate.utc().startOf('day');
                      setSelectedDate(newDate);
                      // console.log(utcDate.format()); // Log the UTC date
                    }}
                    renderInput={(props) => (
                      <TextField {...props} variant="outlined" margin="normal" fullWidth />
                    )}
                    format="MM/DD/YYYY"
                  />
                </DemoItem>
              </DemoContainer>
            </LocalizationProvider>
          </Grid>

          {dateData &&
            <Grid item container xs={12} md={12} lg={12}>
              <Grid item xs={12} md={12} lg={12}>
                <Typography style={{
                  fontWeight: '550'
                }}>
                  Volumes ({Daterow?.length ?? 0})
                </Typography>
                <Button endIcon={<DownloadIcon />} variant="outlined" color="primary" onClick={handleExportToExcelBYDate}>
                  Download
                </Button>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <MainTable columns={columns} rows={Daterow}></MainTable>
              </Grid>
            </Grid>
          }
        </Grid>
      )}
    </>
  )
};

export function ChangesDetails({ showLoading,
  changesDate,
  handlesave,
  setChangesDate,
  columns,
  changestoDate,
  setChangestoDate,
  addedData,
  removeData }) {

  const newdata = addedData?.map(volume => ({
    'Name': volume?.Name,
    'Volumeid': volume?.Volumeid,
    'Type': volume?.Type,
    'Size': volume?.Size,
    'IOPS': volume?.IOPS,
    'Throughput': volume?.Throughput,
    'Created': volume?.Created,
    'Availabilityzone': volume?.Availabilityzone,
    'Attachedresources': volume?.Attachedresources,
    'Volumestate': volume?.Volumestate,
    'Encryption': volume?.Encryption ? 'Encrypted' : 'Not Encrypted',
    'MultiAttachenabled': volume?.MultiAttachenabled ? 'Yes' : 'No',
    "Date": changesDate.format('MM-DD-YYYY'),
  }))
  const olddata = removeData?.map(volume => ({
    'Name': volume?.Name,
    'Volumeid': volume?.Volumeid,
    'Type': volume?.Type,
    'Size': volume?.Size,
    'IOPS': volume?.IOPS,
    'Throughput': volume?.Throughput,
    'Created': volume?.Created,
    'Availabilityzone': volume?.Availabilityzone,
    'Attachedresources': volume?.Attachedresources,
    'Volumestate': volume?.Volumestate,
    'Encryption': volume?.Encryption ? 'Encrypted' : 'Not Encrypted',
    'MultiAttachenabled': volume?.MultiAttachenabled ? 'Yes' : 'No',
    "Date": changestoDate.format('MM-DD-YYYY'),
  }))

  // console.log(newdata)
  const categorizeEC2Instances = (newdata, olddata) => {
    const changesInstances = [];
    const addedInstances = [];
    const removedInstances = [];

    // Check for added instances
    newdata?.forEach(newInstance => {
      const matchingOldInstance = olddata?.find(
        oldInstance =>
          oldInstance['Volumeid'] === newInstance['Volumeid'] ||
          oldInstance['Attachedresources'] === newInstance['Attachedresources']
      );

      if (!matchingOldInstance) {
        addedInstances.push({ ...newInstance, source: 'new' });
      }
    });

    // Check for removed instances
    olddata?.forEach(oldInstance => {
      const matchingNewInstance = newdata?.find(
        newInstance =>
          oldInstance['Volumeid'] === newInstance['Volumeid'] ||
          oldInstance['Attachedresources'] === newInstance['Attachedresources']
      );

      if (!matchingNewInstance) {
        removedInstances.push({ ...oldInstance, source: 'old' });
      }
    });

    newdata?.forEach(newInstance => {
      const matchingOldInstance = olddata?.find(
        oldInstance =>
          oldInstance['Volumeid'] === newInstance['Volumeid'] ||
          oldInstance['Attachedresources'] === newInstance['Attachedresources']
      );

      if (matchingOldInstance) {
        // Check for changes in each property
        const changess = {};
        let hasChanges = false;

        for (const key in newInstance) {
          if (newInstance.hasOwnProperty(key) && matchingOldInstance.hasOwnProperty(key)) {
            if (newInstance[key] !== matchingOldInstance[key]) {
              changess[key] = {
                old: matchingOldInstance[key],
                new: newInstance[key],
              };
              hasChanges = true;
            }
          }
        }

        // If changes are detected, push instances with source
        if (hasChanges) {
          const newValue = Object.values(changess);
          const oldValue = Object.values(changess);
          changesInstances.push({ ...newInstance, source: 'new', newValue: newValue[0].new });
          changesInstances.push({ ...matchingOldInstance, source: 'old', oldValue: oldValue[0].old });
        }
      }
    });

    return {
      changesInstances,
      addedInstances,
      removedInstances,
    };
  };

  const { changesInstances, addedInstances, removedInstances } = categorizeEC2Instances(newdata, olddata);

  return (
    <>
      {showLoading && (
        // Animate the loading indicator (you can replace this with your own loading component)
        <LoadingIndicator></LoadingIndicator>
      )}

      {!showLoading && (
        <Grid container xs={12} md={12} lg={12}>
          <Grid item container xs={12} md={12} lg={12} style={{
            marginBottom: '50px'
          }}>
            <Grid item xs={12} md={6} lg={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DemoItem label="From Date">
                    <DatePicker
                      value={changesDate}
                      onChange={(newDate) => setChangesDate(newDate.startOf('day'))}
                      renderInput={(props) => (
                        <TextField {...props} variant="outlined" margin="normal" fullWidth />
                      )}
                      format="MM/DD/YYYY"
                    />
                  </DemoItem>
                </DemoContainer>
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer sx={{ marginLeft: "1rem" }} components={['DatePicker']}>
                  <DemoItem label="To Date">
                    <DatePicker
                      value={changestoDate}
                      onChange={(newDate) => setChangestoDate(newDate.startOf('day'))}
                      renderInput={(props) => (
                        <TextField {...props} variant="outlined" margin="normal" fullWidth />
                      )}
                      format="MM/DD/YYYY"
                    />
                  </DemoItem>
                </DemoContainer>
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Button sx={{ marginTop: "1rem" }} variant="outlined" color="primary" onClick={handlesave} >Save current data</Button>
            </Grid>
          </Grid>

          <Grid item container xs={12} md={12} lg={12}>
            <Grid item xs={12} md={12} lg={12} style={{
              marginBottom: '20px'
            }}>
              <Typography >Changes {changesInstances?.length === 0 ? `(0)` : ''}</Typography>
              <MainTable columns={columns} rows={changesInstances} ></MainTable>
            </Grid>
            <Grid item xs={12} md={12} lg={12} style={{
              marginBottom: '20px'
            }}>
              <Typography >Added {addedInstances?.length === 0 ? `(0)` : ''}</Typography>
              <MainTable columns={columns} rows={addedInstances} ></MainTable>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Typography >Removed {removedInstances?.length === 0 ? `(0)` : ''}</Typography>
              <MainTable columns={columns} rows={removedInstances} ></MainTable>
            </Grid>
          </Grid>
        </Grid>)}
    </>)
}
